import React from 'react';
import { PillarPage } from '../components/PillarPage';
import { relacionesPage } from '../data/pages/relaciones';
export function Relaciones() {
  return <PillarPage content={relacionesPage} data-id="element-263" data-mp="byu6m5edvrn7" />;
}